"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointCollectionCache = exports.IkeTransformer = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const store_1 = require("../../store");
class IkeTransformer {
    /**
     * Create a caching function to remember the result  of the transformer,
     * This will be automatically updated if any observables change inside the transformer.
     */
    static create(transformer, opts) {
        const views = {};
        function createView(source) {
            const transformerName = `Transformer-${opts.name}-${source}`;
            const expr = (0, mobx_1.computed)(() => transformer(source), { name: transformerName });
            const disposer = (0, mobx_1.onBecomeUnobserved)(expr, () => {
                disposer();
                delete views[source];
            });
            return expr;
        }
        return (obj) => {
            let existing = views[obj];
            if (existing == null) {
                existing = views[obj] = createView(obj);
            }
            return existing.get();
        };
    }
}
exports.IkeTransformer = IkeTransformer;
class PointCollectionCache {
}
exports.PointCollectionCache = PointCollectionCache;
/** Get a list of collection vectors given the collection revision */
PointCollectionCache.getCollectionVectors = IkeTransformer.create((revision) => {
    const collection = store_1.AppStore.Collection.get(revision);
    if (collection == null) {
        return null;
    }
    const output = [];
    collection.forEachField((field) => {
        if (field.value == null) {
            return;
        }
        const collectionLocation = PointCollectionCache.getCollectionLocation(revision);
        if (core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
            const { distance, bearing } = field.value;
            const target = core_shared_1.IkeGeodesic.projectLocation(collectionLocation, bearing, distance);
            output.push({ field, target });
        }
        if (core_shared_1.CollectionModelFieldAnchor.isAnchorField(field)) {
            const { distance, bearing } = field.distanceBearingPitch(collectionLocation);
            const target = core_shared_1.IkeGeodesic.projectLocation(collectionLocation, bearing, distance);
            output.push({ field, target });
        }
    });
    return output;
}, { name: 'getCollectionVectors' });
/** Location is hard to find, so cache the location lookups */
PointCollectionCache.getCollectionLocation = IkeTransformer.create((revision) => {
    const collection = store_1.AppStore.Collection.get(revision);
    if (collection == null) {
        return null;
    }
    // trace();
    return collection.location;
}, { name: 'getCollectionLocation' });
//# sourceMappingURL=point.collection.cache.js.map